/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalSystemCatalogDto } from './MedicalSystemCatalogDto';
import {
    instanceOfMedicalSystemCatalogDto,
    MedicalSystemCatalogDtoFromJSON,
    MedicalSystemCatalogDtoFromJSONTyped,
    MedicalSystemCatalogDtoToJSON,
} from './MedicalSystemCatalogDto';

/**
 * @type JobConfigurationDtoTargetSystem
 * 
 * @export
 */
export type JobConfigurationDtoTargetSystem = MedicalSystemCatalogDto;


export function JobConfigurationDtoTargetSystemFromJSON(json: any): JobConfigurationDtoTargetSystem {
    return JobConfigurationDtoTargetSystemFromJSONTyped(json, false);
}

export function JobConfigurationDtoTargetSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobConfigurationDtoTargetSystem {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...MedicalSystemCatalogDtoFromJSONTyped(json, true) };
    return  MedicalSystemCatalogDtoFromJSONTyped(json, true);
}

export function JobConfigurationDtoTargetSystemToJSON(value?: JobConfigurationDtoTargetSystem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfMedicalSystemCatalogDto(value)) {
        return MedicalSystemCatalogDtoToJSON(value as MedicalSystemCatalogDto);
    }

    return {};
}

/**
 * Check if a given object implements the JobConfigurationDtoTargetSystem interface.
 */
export function instanceOfJobConfigurationDtoTargetSystem(value: any): value is JobConfigurationDtoTargetSystem {
    if (instanceOfMedicalSystemCatalogDto(value)) return true;
    return false;
}

